/**
 * Draw an SVG stroke through `stroke-dashoffset`, the one main-thread property the pieces use; the
 * animation exists only for the draw. The path carries `pathLength="1"` and `stroke-dasharray="1 1"`,
 * so the offset is the share still undrawn. A positive offset grows the stroke from the path's
 * start, a negative one from its end.
 *
 * The undrawn stroke is held with `visibility`, not with the offset alone: at offset 1 or -1 a dash
 * starts exactly at the path's end, a zero-length dash that a round cap paints as a dot (WebKit
 * paints it; Chromium does not). `visibility` interpolates to visible for every progress above zero,
 * where the offset is already below 1, so no frame shows the dot. The markup holds the pending
 * stroke the same way, with `invisible`.
 */

/**
 * @param {SVGElement} stroke
 * @param {{delay: number, duration: number, easing: string}} timing
 * @param {'start' | 'end'} from The end of the path the stroke grows from.
 * @returns {Animation}
 */
export function drawStroke(stroke, timing, from = 'start') {
    return stroke.animate(
        [
            {visibility: 'hidden', strokeDashoffset: from === 'start' ? 1 : -1},
            {visibility: 'visible', strokeDashoffset: 0},
        ],
        {...timing, fill: 'backwards'}
    );
}
